import { onScopeDispose, watch } from 'vue'

import type { Ref } from 'vue'
import type { Track } from 'livekit-client'

export const useMediaBindingLiveKit = <T extends HTMLMediaElement>(
  mediaEl: Ref<T | null>,
  track: Ref<Track | null>,
): void => {
  let attachedEl: T | null = null
  let attachedTrack: Track | null = null

  const detach = (): void => {
    if (attachedTrack && attachedEl) {
      attachedTrack.detach(attachedEl)
    }
    attachedTrack = null
    attachedEl = null
  }

  const sync = (): void => {
    const el = mediaEl.value
    const nextTrack = track.value

    if (attachedTrack === nextTrack && attachedEl === el) return

    detach()

    if (nextTrack && el) {
      nextTrack.attach(el)
      attachedTrack = nextTrack
      attachedEl = el
    }
  }

  watch([mediaEl, track], sync, { immediate: true })

  onScopeDispose(detach)
}
